module.exports = __webpack_public_path__ + "img/DSC_2728-xs.43dd4b13.png";